<template>
  <div>
    <div class="d-flex align-center">
      <v-icon
        class="mr-2"
        size="30"
        :color="$vuetify.theme.primary || '#39424e'"
        @click="$emit('back')"
      >
        mdi-arrow-left-circle
      </v-icon>
      <span class="ml-3 navigation-title"> Formulário da Cotação </span>
    </div>

    <v-form ref="form">
      <v-row class="ma-0 mr-5 mt-8" dense>
        <!-- <v-col class="py-0" cols="12" sm="4">
          <span class="label-bold">Código do Produto</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="Ex: 23232123"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="proposal.cd_produto"
          ></v-text-field>
        </v-col> -->

        <v-col class="py-0" cols="12" sm="4">
          <span class="label-bold">Documento do Segurado</span>
          <v-text-field
            dense
            class="primary-input"
            outlined
            placeholder="CPF"
            disabled
            v-model="proposal.nr_cnpj_cpf_segurado"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            hide-details
            :value="(proposal.nr_cnpj_cpf_segurado = user.nr_cpf_cnpj)"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="12" sm="7">
          <span class="label-bold">Atividade</span>
          <v-autocomplete
            dense
            class="secondary-input"
            append-icon="mdi-chevron-down"
            outlined
            :items="activities"
            item-text="nm_atividade"
            item-value="id_atividade"
            placeholder="Selecione"
            hide-details
            v-model="proposal.id_atividade"
            @change="recalculateProposal"
          ></v-autocomplete>
          <v-checkbox
            label="Não encontrei minha especialidade"
            dense
            color="primary"
            v-model="nothingActivity"
            @change="installmentsVisible = !installmentsVisible"
          ></v-checkbox>
        </v-col>

        <v-expand-transition>
          <v-col cols="12" v-show="nothingActivity">
            <h2>Dados adicionais</h2>
          </v-col>
        </v-expand-transition>
        <v-expand-transition>
          <v-col v-show="nothingActivity" class="py-0" cols="12" sm="6">
            <span class="label-bold">Especialidade</span>
            <v-text-field
              dense
              class="secondary-input"
              outlined
              placeholder="Digite sua especialidade"
              v-model="proposal.specialty"
            ></v-text-field>
          </v-col>
        </v-expand-transition>
        <v-expand-transition>
          <v-col v-show="nothingActivity" class="py-0" cols="12" sm="6">
            <span class="label-bold">Importância segurada</span>
            <v-text-field
              dense
              class="secondary-input"
              outlined
              placeholder="Digite a importância segurada"
              v-model="proposal.insuredAmount"
            ></v-text-field>
          </v-col>
        </v-expand-transition>
        <!-- <v-expand-transition>
          <v-col v-show="nothingActivity" class="py-0" cols="12" sm="4">
            <span class="label-bold">Seguradora</span>
            <v-text-field
              dense
              class="secondary-input"
              outlined
              placeholder="Digite a seguradora"
              v-model="proposal.insurer"
            ></v-text-field>
          </v-col>
        </v-expand-transition> -->

        <v-col class="py-0" cols="12" sm="5">
          <span class="label-bold">Renovação</span>
          <v-autocomplete
            dense
            class="secondary-input"
            append-icon="mdi-chevron-down"
            outlined
            :items="renovationOptions"
            item-text="name"
            item-value="value"
            placeholder="Selecione"
            v-model="renovacao"
            @change="installmentsVisible = false"
          ></v-autocomplete>
        </v-col>

        <v-col v-if="renovacao == 2" class="py-0" cols="6" sm="4">
          <span class="label-bold">Renovação de qual CIA?</span>
          <v-text-field
            dense
            class="secondary-input"
            outlined
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="otherInsurerName"
          ></v-text-field>
        </v-col>

        <v-col v-if="apoliceFatorVisible" class="py-0" cols="6" sm="4">
          <span class="label-bold">Apólice Fator</span>
          <v-text-field
            dense
            class="secondary-input"
            outlined
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="proposal.cd_apolice_fator"
          ></v-text-field>
        </v-col>

        <v-col v-if="retroatividadeVisible" class="py-0" cols="12" sm="4">
          <span class="label-bold">Data de Retroatividade</span>
          <v-text-field
            dense
            class="secondary-input"
            outlined
            v-mask="'#'"
            placeholder="Ex: 1 ano"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="proposal.dt_retroatividade"
          ></v-text-field>
        </v-col>

        <v-col class="py-0" cols="6" sm="3">
          <span class="label-bold">Início Vigência</span>
          <v-text-field
            dense
            class="secondary-input"
            outlined
            v-mask="'##/##/####'"
            placeholder="00/00/0000"
            :rules="[
              (v) => !!v || 'Campo obrigatório',
              (v) =>
                generalService.validateVigency(v) ||
                'Data superior a 35 dias da data atual',
              (v) => generalService.validateDate(v) || 'Data inválida',
            ]"
            v-model="proposal.dt_inicio_vigencia"
            @change="recalculateProposal"
          ></v-text-field>
        </v-col>

        <v-col
          v-if="proposal.cd_tipo_pessoa == 2"
          class="py-0"
          cols="12"
          sm="5"
        >
          <span class="label-bold">Faturamento</span>
          <v-currency-field
            prefix="R$"
            dense
            class="secondary-input"
            outlined
            placeholder="Digite o faturamento"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="proposal.vl_faturamento"
            @change="recalculateProposal"
          ></v-currency-field>
        </v-col>

        <v-col class="py-0" cols="6" sm="4">
          <span class="label-bold">Limite Máximo de Indenização</span>
          <v-select
            dense
            class="secondary-input"
            append-icon="mdi-chevron-down"
            outlined
            placeholder="Selecione"
            item-text="text"
            item-value="value"
            :items="lmgs"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="proposal.vl_lmg"
            @change="recalculateProposal"
          ></v-select>
        </v-col>

        <v-col class="py-0" cols="8" sm="6">
          <span class="label-bold">Franquias</span>
          <v-select
            dense
            class="secondary-input"
            append-icon="mdi-chevron-down"
            outlined
            placeholder="Selecione"
            item-text="nm_descricao_franquia"
            item-value="id_franquia"
            :items="franquias"
            @change="recalculateProposal"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="proposal.id_franquia"
          ></v-select>
        </v-col>

        <v-col cols="12" v-if="installmentsVisible">
          <v-img
            src="../../../../assets/fator.jpg"
            contain
            height="100px"
            width="200px"
          ></v-img>
          <h3 class="mb-2">Coberturas:</h3>

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <strong>Coberturas Básicas</strong>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <table class="table-coverages">
                  <thead>
                    <tr>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Nome da cobertura
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Sublimite
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Franquia
                      </th>
                      <th
                        style="border: 1px solid #ddd"
                        class="text-center pa-3"
                      >
                        Detalhes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(coverage, i) in coverages.basic_coverages"
                      :key="i"
                    >
                      <td class="text-left pl-3">{{ coverage.name }}</td>
                      <td class="text-left pl-3">{{ coverage.sublimit }}</td>
                      <td class="text-left pl-3">{{ coverage.franquia }}</td>
                      <td class="text-center">
                        <v-icon
                          @click="openDialog(coverage)"
                          :color="$vuetify.theme.primary || '#34d2c7'"
                          >mdi-eye</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <strong>Extensões de Coberturas</strong>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <table class="table-coverages">
                  <thead>
                    <tr>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Nome da cobertura
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Sublimite
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Franquia
                      </th>
                      <th style="border: 1px solid #ddd" class="text-left pa-3">
                        Detalhes
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(coverage, i) in coverages.extesions_coverages"
                      :key="i + 1"
                    >
                      <td class="text-left pl-3">
                        <span>{{ coverage.name }}</span>
                      </td>
                      <td class="text-left pl-3">
                        <span>{{ coverage.sublimit }}</span>
                      </td>
                      <td class="text-left pl-3">
                        <span>{{ coverage.franquia }}</span>
                      </td>
                      <td class="text-center">
                        <v-icon
                          @click="openDialog(coverage)"
                          :color="$vuetify.theme.primary || '#34d2c7'"
                          >mdi-eye</v-icon
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-dialog
            max-width="600px"
            v-model="coverageDialog"
            v-if="coverageDialog"
          >
            <v-card class="pa-4">
              <v-card-title class="headline">
                {{ currentCoverage.name }}
              </v-card-title>
              <v-card-text v-html="currentCoverage.description"> </v-card-text>
              <v-divider class="mx-4"></v-divider>
              <p class="d-flex flex-column pa-4">
                <span
                  ><strong>Sublimite: </strong>
                  {{ currentCoverage.sublimit }}</span
                >
                <span
                  ><strong>Franquia: </strong>
                  {{ currentCoverage.franquia }}</span
                >
              </p>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :color="$vuetify.theme.primary || '#34d2c7'"
                  style="
                    text-transform: none;
                    color: var(--custom-white-second-color);
                  "
                  @click="coverageDialog = false"
                >
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>

        <div
          v-if="installmentsVisible && !loading"
          style="
            width: 100%;
            margin: 2rem auto;
            height: 1px;
            background-color: var(--custom-second-color);
          "
        ></div>

        <v-col cols="12" v-if="installmentsVisible && !loading">
          <h3 class="mb-2">Prêmio do Seguro:</h3>
          <table
            style="
              width: 80%;
              border-collapse: collapse;
              border: 1px solid #ddd;
              margin: 20px;
            "
          >
            <tr v-if="proposal.nr_parcelas && currentInstallment">
              <td>Parcela</td>
              <td>
                {{ currentInstallment.nr_parcelas }}x
                {{ currentInstallment.juros ? "c/Juros" : "s/Juros" }}
                de
                {{
                  Number(resultProposal.proposal.vl_parcela).toLocaleString(
                    "pt-BR",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )
                }}
              </td>
            </tr>
            <tr>
              <td>Prêmio Líquido</td>
              <td>
                {{
                  Number(resultProposal.proposal.vl_tarifario).toLocaleString(
                    "pt-BR",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )
                }}
              </td>
            </tr>
            <tr>
              <td>IOF</td>
              <td>7,38%</td>
            </tr>
            <tr>
              <td>Prêmio Total</td>
              <td>
                {{
                  Number(resultProposal.proposal.vl_total).toLocaleString(
                    "pt-BR",
                    {
                      style: "currency",
                      currency: "BRL",
                    }
                  )
                }}
              </td>
            </tr>
          </table>
        </v-col>

        <v-col
          v-if="installmentsVisible && !loading"
          class="py-0"
          cols="6"
          sm="4"
        >
          <span class="label-bold">Parcelamentos</span>
          <v-select
            dense
            class="secondary-input"
            append-icon="mdi-chevron-down"
            outlined
            placeholder="Selecione"
            item-text="descricao"
            item-value="nr_parcelas"
            :items="installments"
            return-object
            :rules="[(v) => !!v || 'Campo obrigatório']"
            v-model="currentInstallment"
            @change="cotar"
          ></v-select>
        </v-col>

        <v-col cols="12" class="d-flex justify-end mb-5">
          <v-btn
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            class="primary-button"
            @click="cotar"
            :loading="loading"
          >
            {{ !isAlreadyQuote ? "Cotar" : "Recalcular" }}
            <v-icon class="ml-2">mdi-restart</v-icon>
          </v-btn>
          <v-btn
            v-if="isAlreadyQuote"
            :style="
              $vuetify.theme.primary
                ? `color: var(--custom-white-second-color) !important; background-color: ${$vuetify.theme.primary} !important;`
                : 'color: var(--custom-white-second-color) !important;'
            "
            class="primary-button ml-2"
            @click="submit"
            :loading="loading"
          >
            Visualizar Resumo Cotação
            <v-icon class="ml-2">mdi-arrow-right-bold-circle-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>
.label-bold {
  white-space: nowrap !important;
}
</style>

<script>
import GeneralService from "../../../../services/GeneralServices";
import ApiService from "../../../../services/ApiService";
import coverages from "../../../../assets/coverages.json";
import activities from "../../../../assets/activities.json";
import moment from "moment";
export default {
  name: "personal",

  props: {
    user_prop: Object,
  },

  created() {
    const styleElement = document.createElement("style");
    styleElement.textContent = `:root {
      --custom-primary-color: ${this.$vuetify.theme.primary || "#00C7BA"};
      --custom-second-color: ${this.$vuetify.theme.primary || "#39424E"};
      --custom-white-color: ${
        this.$store.state.socio
          ? !this.isColorDark(this.$store.state.socio.cor)
            ? "#013"
            : "#fff"
          : "#00C7BA"
      };
      --custom-white-second-color: ${
        this.$store.state.socio
          ? !this.isColorDark(this.$store.state.socio.cor)
            ? "#013"
            : "#fff"
          : "#fff"
      };
     }`;
    document.head.appendChild(styleElement);
    this.user = this.user_prop;

    this.getPartner();
    this.proposal.Questionario = JSON.parse(
      localStorage.getItem("questions")
    ).map((x) => {
      return {
        id_pergunta: x.id_pergunta,
        id_resposta: x.id_resposta,
        nm_justificativa: x.nm_justificativa,
      };
    });
  },

  data() {
    return {
      coverages: coverages,
      coverageDialog: false,
      currentCoverage: null,
      coverageKey: false,
      loading: false,
      nothingActivity: false,
      modal: false,
      api: new ApiService(),
      cepLoading: false,
      activities: activities,
      renovacao: null,
      proposal: {
        nm_login: "globuscor", //fixo
        id_pessoa_corretor: "5351827", //fixo
        cd_produto: "12095", //fixo
        // dt_proposta: null,
        cd_tipo_pessoa: 1,
        id_pessoa_segurado: null,
        nr_cnpj_cpf_segurado: null,
        id_modalidade: 4,
        id_atividade: null,
        vl_faturamento: null,
        dv_renovacao: null,
        dv_renovacao_congenere: null,
        cd_apolice_fator: null,
        dt_retroatividade: null,
        dt_inicio_vigencia: null,
        vl_lmg: null,
        cd_forma_pagamento: "1000008",
        pe_comissao: "20",
        // id_parcelas: 737, //a vista
        nr_parcelas: "1",
        id_franquia: "6", //franquia fixa
        Questionario: [],
      },
      otherInsurerName: null,
      isAlreadyQuote: false,
      generalService: new GeneralService(),
      generalOptions: ["Sim", "Não"],
      insured: null,
      franquias: [
        {
          id_franquia: 6,
          nm_descricao_franquia: "Franquia Fixa",
        },
        {
          id_franquia: 7,
          nm_descricao_franquia: "P.O.S. 10%",
        },
        {
          id_franquia: 8,
          nm_descricao_franquia: "P.O.S. 15%",
        },
      ],
      lmgs: [
        {
          text: "R$ 100.000,00",
          value: 100000,
        },
        {
          text: "R$ 200.000,00",
          value: 200000,
        },
        {
          text: "R$ 300.000,00",
          value: 300000,
        },
        {
          text: "R$ 400.000,00",
          value: 400000,
        },
        {
          text: "R$ 500.000,00",
          value: 500000,
        },
        {
          text: "R$ 600.000,00",
          value: 600000,
        },
        {
          text: "R$ 700.000,00",
          value: 700000,
        },
        {
          text: "R$ 800.000,00",
          value: 800000,
        },
        {
          text: "R$ 900.000,00",
          value: 900000,
        },
        {
          text: "R$ 1.000.000,00",
          value: 1000000,
        },
      ],
      installments: [
        {
          id_parcela: 737,
          nr_parcelas: 1,
          descricao: "A vista (BOLETO)",
          juros: false,
        },
        {
          id_parcela: 739,
          nr_parcelas: 2,
          descricao: "2 vezes sem juros (BOLETO)",
          juros: false,
        },
        {
          id_parcela: 740,
          nr_parcelas: 3,
          descricao: "3 vezes sem juros (BOLETO)",
          juros: false,
        },
        {
          id_parcela: 736,
          nr_parcelas: 4,
          descricao: "4 vezes sem juros (BOLETO)",
          juros: false,
        },
        {
          id_parcela: 803,
          nr_parcelas: 5,
          descricao: "5 vezes sem juros (BOLETO)",
          juros: false,
        },
        {
          id_parcela: 836,
          nr_parcelas: 6,
          descricao: "6 vezes com juros (BOLETO)",
          juros: true,
        },
        {
          id_parcela: 738,
          nr_parcelas: 7,
          descricao: "7 vezes com juros (BOLETO)",
          juros: true,
        },
        {
          id_parcela: 1095,
          nr_parcelas: 8,
          descricao: "8 vezes com juros (BOLETO)",
          juros: true,
        },
        {
          id_parcela: 837,
          nr_parcelas: 9,
          descricao: "9 vezes com juros (BOLETO)",
          juros: true,
        },
      ],
      renovationOptions: [
        { name: "Não", value: 0 },
        { name: "Sim, da Fator Seguradora", value: 1 },
        { name: "Sim, mas de outra Seguradora", value: 2 },
      ],
      cpfRules: [
        (v) => !!v || "Insira seu CPF completo",
        (v) => this.generalService.validateCPF(v) || "CPF inválido",
      ],
      retroatividadeVisible: false,
      apoliceFatorVisible: false,
      installmentsVisible: false,
      resultProposal: null,
      currentInstallment: null,
      disableVigency: false,
      id_endosso: null,
      cd_proposta: null,
    };
  },
  watch: {
    renovacao(val) {
      switch (val) {
        case 0:
          this.proposal.dv_renovacao = false;
          this.proposal.dv_renovacao_congenere = false;
          this.apoliceFatorVisible = false;
          this.retroatividadeVisible = false;
          this.proposal.dt_inicio_vigencia = moment().format("DD/MM/YYYY");
          this.disableVigency = true;
          break;
        case 1:
          this.proposal.dv_renovacao = true;
          this.apoliceFatorVisible = true;
          this.retroatividadeVisible = false;
          this.proposal.dv_renovacao_congenere = false;
          this.disableVigency = false;
          this.proposal.dt_inicio_vigencia = null;
          break;
        case 2:
          this.proposal.dv_renovacao = true;
          this.apoliceFatorVisible = false;
          this.retroatividadeVisible = true;
          this.proposal.dv_renovacao_congenere = true;
          this.disableVigency = false;
          this.proposal.dt_inicio_vigencia = null;
          break;
      }
    },
  },

  methods: {
    downloadArchive() {
      const link = document.createElement("a");
      link.href =
        "https://globusrcmedico-back.azurewebsites.net/riscosFator.pdf";
      link.setAttribute("download", "Codições Gerais.pdf");
      document.body.appendChild(link);
      link.click();
    },
    async getPartner() {
      if (localStorage.getItem("id_parceiro")) {
        this.api
          .get(
            `https://globusesteiraback.azurewebsites.net/api/partner/id-corretor?id_parceiro=${localStorage.getItem(
              "id_parceiro"
            )}`
          )
          .then((response) => {
            this.proposal.id_pessoa_corretor =
              response.data?.id_corretor_fator || "5351827";
          })
          .catch(() => {});
      }
    },
    searchCep() {
      if (this.user.nm_cep.length < 9) {
        return;
      }

      this.cepLoading = true;

      this.api
        .get(`cep?number=${this.user.nm_cep?.replace("-", "")}`)
        .then((res) => {
          this.user.nm_endereco = res.logradouro;
          this.user.nm_bairro = res.bairro;
          this.user.nm_cidade = res.localidade;
          this.user.nm_uf = res.uf;
          this.user.nr_ddd = res.ddd;

          this.cepLoading = false;
        })
        .catch(() => {
          localStorage.setItem(
            "apiErrorDescription",
            "Erro ao buscar o CEP! - PROPOSTA"
          );
          this.cepLoading = false;
        });
    },
    openDialog(coverage) {
      this.currentCoverage = coverage;
      this.coverageDialog = true;
    },
    closeDialog() {
      this.coverageDialog = false;
      this.currentCoverage = null;
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.formattedProposal();
        this.loading = false;
        this.$emit("next", 3);
      }
    },
    recalculateProposal() {
      if (this.isAlreadyQuote) {
        this.isAlreadyQuote = false;
        this.cotar();
      }
    },
    formattedProposal() {
      const proposal = { ...this.proposal };

      const convertToString = (value) => value?.toString() || "0";
      const convertDate = (date) => date?.split("/").reverse().join("") || "";

      proposal.vl_lmg = convertToString(proposal.vl_lmg);
      proposal.vl_faturamento = convertToString(proposal.vl_faturamento);
      proposal.id_pessoa_segurado = this.user.id_pessoa;
      proposal.nr_cnpj_cpf_segurado =
        this.proposal.nr_cnpj_cpf_segurado?.replace(/[^0-9]/g, "");
      proposal.dt_inicio_vigencia = convertDate(
        this.proposal.dt_inicio_vigencia
      );
      proposal.id_atividade = proposal.id_atividade?.toString();
      proposal.pe_comissao = proposal.pe_comissao?.toString();
      proposal.dv_renovacao_congenere =
        proposal?.dv_renovacao_congenere?.toString();
      proposal.dv_renovacao = proposal?.dv_renovacao?.toString();
      proposal.dt_retroatividade = convertDate(proposal.dt_retroatividade);
      proposal.id_franquia = proposal.id_franquia?.toString();
      proposal.id_modalidade = proposal.id_modalidade?.toString();
      proposal.cd_apolice_fator = proposal.cd_apolice_fator?.toString();

      const handleRenewalDeletion = () => {
        if (proposal.dv_renovacao == "false") {
          delete proposal.cd_apolice_fator;
          delete proposal.dv_renovacao_congenere;
        } else if (
          proposal.dv_renovacao_congenere == "false" &&
          proposal.dv_renovacao == "false"
        ) {
          delete proposal.cd_apolice_fator;
        }
      };

      handleRenewalDeletion();

      localStorage.removeItem("proposal");
      localStorage.setItem("proposal", JSON.stringify(proposal));

      return proposal;
    },
    async cotar() {
      this.loading = true;

      const proposal = this.formattedProposal();
      const questions = JSON.parse(localStorage.getItem("questions"));
      const questionsTrue = questions.filter((q) => q.resposta == true);
      if (
        questionsTrue.length > 0 ||
        this.otherInsurerName ||
        this.nothingActivity
      ) {
        await this.createProposalRejected(proposal, questions);
      } else {
        if (this.isAlreadyQuote) {
          await this.recalculate(proposal, questions);
        } else {
          await this.createProposal(proposal, questions);
        }
      }

      this.loading = false;
    },
    async recalculate(proposal, questions) {
      this.loading = true;

      const response = await this.api.put("update-proposal", {
        proposal: {
          id_pessoa_corretor: this.proposal.id_pessoa_corretor,
          id_endosso: this.id_endosso,
          cd_proposta: this.cd_proposta,
          nr_parcelas: this.currentInstallment.nr_parcelas,
          id_franquia: proposal.id_franquia,
          dt_inicio_vigencia: proposal.dt_inicio_vigencia,
          // cd_forma_pagamento: this.proposal.cd_forma_pagamento,
        },
        token: localStorage.getItem("token"),
        queryInfos: JSON.parse(localStorage.getItem("queryInfos")),
        user: JSON.parse(localStorage.getItem("user")),
        questions,
      });

      if (response.cd_retorno == 0) {
        this.id_endosso = response.Retorno.RetornoTable1[0].id_endosso;
        this.cd_proposta = response.Retorno.RetornoTable1[0].cd_proposta;
        const dataProposal = response.Retorno.RetornoTable1[0];
        this.resultProposal = {
          proposal: {
            ...dataProposal,
            nm_segurado: this.resultProposal.proposal.nm_segurado,
            nm_status_proposta: this.resultProposal.proposal.nm_status_proposta,
          },
          parcelas:
            response.Parcelamentos_disponiveis
              .Parcelamentos_disponiveis_table_1,
          franquias:
            response.Franquias_disponiveis.Franquias_disponiveis_table_1,
        };

        this.franquias = this.resultProposal.franquias;

        localStorage.removeItem("resultProposal");
        localStorage.setItem(
          "resultProposal",
          JSON.stringify(this.resultProposal)
        );
        this.loading = false;
        this.installmentsVisible = true;
        this.$toast.success(response.nm_retorno);
      } else {
        localStorage.setItem(
          "apiErrorDescription",
          "Erro ao atualizar a proposta!"
        );
        this.$toast.error(response.nm_retorno || "Erro na comunicação");
      }

      this.loading = false;
    },
    async createProposal(proposal, questions) {
      const response = await this.api.post("create-proposal", {
        proposal: {
          ...proposal,
          id_parceiro: localStorage.getItem("id_parceiro"),
          creator_cpf: localStorage.getItem("creator_cpf"),
        },
        token: localStorage.getItem("token"),
        queryInfos: JSON.parse(localStorage.getItem("queryInfos")),
        user: JSON.parse(localStorage.getItem("user")),
        questions,
      });

      if (response.cd_retorno == 0) {
        await this.generalService.saveSessionInfo({
          quoted: true
        });

        this.isAlreadyQuote = true;
        this.id_endosso = response.Retorno.Retorno[0].id_endosso;
        this.cd_proposta = response.Retorno.Retorno[0].cd_proposta;
        this.resultProposal = {
          proposal: response.Retorno.Retorno[0],
          parcelas:
            response.Parcelamentos_disponiveis
              .Parcelamentos_disponiveis_table_1,
          franquias:
            response.Franquias_disponiveis.Franquias_disponiveis_table_1,
        };

        this.franquias = this.resultProposal.franquias;

        this.currentInstallment = this.installments.find(
          (i) => i.nr_parcelas == this.proposal.nr_parcelas
        );

        localStorage.removeItem("resultProposal");
        localStorage.setItem(
          "resultProposal",
          JSON.stringify(this.resultProposal)
        );
        this.installmentsVisible = true;
        this.loading = false;

        this.$toast.success(response.nm_retorno);
      } else {
        localStorage.setItem(
          "apiErrorDescription",
          "Erro ao criar a proposta!"
        );
        this.$toast.error(response.nm_retorno || "Erro na comunicação");
      }

      this.loading = false;
    },
    async createProposalRejected(proposal, questions) {
      await this.api
        .post("create-proposal-rejected", {
          proposal: {
            ...proposal,
            Questionario: JSON.stringify(questions),
            id_parceiro: localStorage.getItem("id_parceiro"),
            creator_cpf: localStorage.getItem("creator_cpf"),
            id_pessoa_segurado: this.user.id_pessoa,
            other_insurer_name: this.otherInsurerName,
          },
          queryInfos: JSON.parse(localStorage.getItem("queryInfos")),
        })
        .then((response) => {
          // this.$toast.info('Infelizmente você pode prosseguir!')
          this.$router.push({ name: "problem" });
        })
        .catch((error) => {
          localStorage.setItem(
            "apiErrorDescription",
            "Erro ao criar a a proposta rejeitada!"
          );
          this.$router.push({ name: "problem" });
        });
    },
    isColorDark(color) {
      if (!color) {
        return false;
      }
      const luminosity = this.calculateLuminosity(color);
      return luminosity < 128;
    },
    isColorLight(color) {
      return !this.isColorDark(color);
    },
    calculateLuminosity(color) {
      const rgb = this.hexToRgb(color);
      const luminosity = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;
      return luminosity * 255;
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.replace("#", ""), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return {
        r: r / 255,
        g: g / 255,
        b: b / 255,
      };
    },
  },
};
</script>

<style scoped>
table tr td {
  padding: 5px;
  border: 1px solid #ccc;
}

table tr td:first-child {
  font-weight: bold;
}

table tr td:last-child {
  padding-left: 10px;
}

.table-coverages {
  width: 80%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  margin: 20px;
}

.table-coverages tr td {
  font-weight: normal !important;
}
</style>
